import { EnvironmentType } from '@ls/models-environment';
import { Environment } from '../models/environment.model';
import { forkJoin, map, Observable } from 'rxjs';
import { Translations } from '../models/translations.model';
import { REGIONALIZATION_DEFAULT_LANGUAGE } from '@ls/models-regionalization';

export const buildTranslationsFileName = (languageCode: string): string => {
  const languageCodeFormatted = languageCode.toLowerCase().replace('_', '-');

  return `translations.${languageCodeFormatted}.json`;
};

export const checkShouldOverrideWithLocalTranslations = (
  environment: Environment
): boolean => {
  return environment.type === EnvironmentType.Local;
};

export const checkShouldUseSourceTranslations = (
  languageCode: string
): boolean => {
  return languageCode === REGIONALIZATION_DEFAULT_LANGUAGE.code;
};

export const loadMultipleTranslationsAndMergePreservingOrder = (
  ...translationObservables: Observable<Translations>[]
): Observable<Translations> =>
  forkJoin(translationObservables).pipe(
    map((allTranslations) =>
      allTranslations.reduce(
        (acc, translations) => ({
          ...acc,
          ...translations,
        }),
        {}
      )
    )
  );
